/**
 * Shared Leaflet library for the map content element.
 *
 * Kept in its own bundle like Swiper and GSAP: only pages with a map pay for it, and the feature
 * bundle picks the global up at Alpine init. The stylesheet is imported here, so esbuild emits
 * lib/leaflet.min.css next to the script.
 */
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

window.L = L
